import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Tradesy'
        title='Tradesy Shipping 101: The Essentials to Get You Started'
      >
        <p>
          Sellers’ shipping options, the pros and the cons, and all there is to know about sending items to buyers on
          Tradesy.{' '}
        </p>
        <p>
          Upfront, there are two good things about selling on Tradesy. First, they let the sellers know their estimated
          earnings minus Tradesy’s fees even before publishing their listings. This way, they could adjust their pricing
          to achieve their desired profit when a buyer purchases their item.{' '}
        </p>
        <p>
          Second – which we will be discussing at length in this article – is that they allow sellers to choose among
          the three convenient shipping methods and still change it any time before the item sells. This option is
          available for all kinds of items except those under the Weddings category (gowns, accessories, etc.), which
          the sellers themselves must ship.{' '}
        </p>
        <p>
          Read and pick from the three shipping methods below if you haven’t tried selling on Tradesy yet. You might
          even want to try two or all of these methods to see which one works best for you!{' '}
        </p>

        <p>
          <strong>1) SELLERS TO SHIP ON THEIR OWN.</strong> Tradesy offers this method to sellers who prefer to go the
          DIY route. They lend support by providing a shipping calculator for the estimated postage and space beside the
          item’s listing price where the seller can input the estimated shipping fee – both of which will be paid by the
          buyer upon checkout. The seller’s responsibility is to provide the valid tracking number as soon as it’s
          available for the shipping status to be visible to all parties (seller, buyer, Tradesy), starting with the
          first scan of the package.{' '}
        </p>
        <p>
          <strong>The pros:</strong> Sellers have the liberty to choose from not just one shipping carrier such as USPS,
          FedEx, DHL, and UPS. They also get to enjoy the flexibility of printing their shipping label and dispatching
          the package with their chosen carrier. It might be a favorable option if you don’t mind handling the
          nitty-gritty of preparing the shipment and if you live or work close to a carrier branch.{' '}
        </p>
        <p>
          <strong>The cons:</strong> In determining the seller’s price to cover shipping, factors such as distance,
          size, and weight of the shipment and any applicable extra charges need to be considered. The deficit in
          shipping fee could be charged to the buyer upon delivery of the package, which will most likely lead to a
          complaint or leave unsavory feedback as the buyer already paid for both the item price and shipping cost. Only
          choose this option if you trust yourself to be meticulous with the details and have fairly substantial
          experience handling shipping-related tasks.{' '}
        </p>

        <p>
          <strong>2) SELLERS TO SHIP USING A PREPAID LABEL.</strong> If this option is chosen, the buyer will pay a
          fixed shipping expense of $12.80 on top of the item’s price. An extra charge may be added for shipments valued
          at $500 and above or require a signature on delivery. There’s a choice between USPS and FedEx. The prepaid
          label, which already comes with active tracking and insurance, will be automatically generated and ready to
          print.
        </p>
        <p>
          <strong>The pros:</strong> There’s no need to stress over calculating and estimating the shipping fee with
          this option. It also offers the sellers the flexibility of using the carrier’s packaging or using their
          materials (provided it’s clean, sturdy, and with no visible old barcodes and labels), and whether or not to
          drop the shipment off at the branch or local post office, or to schedule a pick-up.
        </p>
        <p>
          <strong>The con:</strong> Some potential buyers may balk at the flat shipping fee, especially if they purchase
          only a small item.{' '}
        </p>

        <p>
          <strong>3) SELLERS TO SHIP USING THE TRADESY SHIPPING KIT.</strong> If this option is availed, Tradesy will
          deliver its shipping kit to the seller 3-5 business days after the item gets sold. The kit comes with a nice
          polybag or box (the system will suggest the most appropriate size depending on the item) and a prepaid USPS
          Priority Mail label already with tracking and addressed to the buyer. The cost of the kit will depend on the
          size of the polybag or box.{' '}
        </p>
        <p>
          <strong>The pros:</strong> This is the best option for busy sellers who simply place the purchased item into
          ready-to-go packaging with a printed label. The only thing left for you to do is swing by the USPS to hand off
          the shipment or call USPS to schedule a pick-up.{' '}
        </p>
        <p>
          <strong>The cons:</strong> Unlike the two other options, you cannot process the shipment until you get the
          shipping kit. The delay of the kit’s delivery will affect the days of delivery to your buyer. Suppose you’ve
          already chosen this option and eventually decided you couldn’t wait a few days to receive the kit. In that
          case, you can request a new prepaid label with new tracking that you can then print and send with your chosen
          packaging – same with the second shipping method.{' '}
        </p>

        <p>
          Regardless of the option you choose, here are some tips to help you achieve a seamless shipping experience:{' '}
        </p>
        <p>
          <strong>Observe Tradesy’s shipping guidelines for every transaction.</strong> Confirm the sale right away or
          within four days of the order date. Make sure you check your email or Tradesy account for an alert at least
          once a day, so you don’t miss anything. Also, ensure you’re factoring in the insurance and signature on
          delivery whenever applicable. Likewise, don’t ever wait longer than the 10th day to ship the item out and
          provide an active tracking number, or else Tradesy will cancel the order. It is encouraged to dispatch the
          item by Day 8 to leave a little wiggle room for delays on the first scan.
        </p>
        <p>
          <strong>
            Always check if the correct item is inside the correct package with the correct buyer’s name and shipping
            address!
          </strong>{' '}
          This extra step will not take more than a minute and can save you from the stress of mix-ups, especially
          during peak season.{' '}
        </p>
        <p>
          <strong>
            Regarding stress, going through the missing package process is also something you’d want to avoid.
          </strong>{' '}
          Make it a habit to stay on top of your new messages (provide a valid email address and phone number). This
          way, you are not just updated on sale updates, but also, you can check recent purchases. In addition to this,
          you are also in the loop regarding shipping issues so that if a minor problem arises, you could still nip it
          in the bud if you respond fast to the carrier without turning into a full-blown mix-up.{' '}
        </p>
        <p>
          <strong>
            If you see yourself being in the reselling business for a long time, consider investing in a thermal printer
            if you haven’t already.
          </strong>{' '}
          Use it to print the label directly from your device, whether it’s an Android app or iOS app or from a browser.
          Also, you must maintain a well-stocked supply of everything you need for shipping, like an assortment of boxes
          and envelopes, rolls of packing tape, packaging tissues, your label stickers, or other branding elements.{' '}
        </p>

        <p>
          Now, shipping parcel is just a part of managing a reselling business. To truly thrive in platforms like
          Tradesy and Poshmark, you need to find ways to be efficient and let an intelligent and reliable bot handle and
          automate tasks. Happy reselling!{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
